export enum FiltersExpressions {
  And = "And",
  Or = "Or"
}